/* global App */
const BaseRouter = require('./base')
const views = require('./views')

module.exports = BaseRouter.extend({
    initialize () {
        this.routings.push({
            key: 'emptyView',
            path: new RegExp(App.urlRegexTo('col') + '.*$'),
            view: views.EmptyView
        })
        this.routings.push({
            key: 'requestPasswordReset',
            path: new RegExp(`${App.urlRegexTo('account/request-password-reset')}.*$`),
            view: views.AccountRequestPasswordResetView,
        })
        this.routings.push({
            key: 'resetPassword',
            path: new RegExp(App.urlRegexTo('user/account/reset-password')),
            view: views.AccountResetPasswordView,
        })
        this.generateRoutes()
    },
})
